@for (deliveryArticle of articles(); track deliveryArticle.id) {
  <div class="label">
    <div class="article-number ellipsis">{{ deliveryArticle.mainArticle.internalId }}</div>
    <div class="article-title">{{ deliveryArticle.mainArticle.title }}</div>
    <div class="footer">
      <div class="field location">
        <div class="caption">Lagerort</div>
        <div class="value ellipsis">{{ deliveryArticle.storageLocation.label }}</div>
      </div>
      <div class="field quantity">
        <div class="caption">Menge</div>
        <div class="value">{{ deliveryArticle.count }} {{ deliveryArticle.mainArticle.unitOfMeasure }}</div>
      </div>
    </div>
  </div>
}
